'use strict'

angular
	.module('ATMGurusLogin', [])
	.controller('LoginController', LoginController)


LoginController.$inject = ['$location', 'Auth', 'User', 'ErrorService', '$rootScope', '$scope', 'Loader', 'Analytics']

function LoginController ($location, Auth, User, ErrorService, $rootScope, $scope, Loader, Analytics) {

	Loader.hide()
	
	this.errorMsg = '';
	this.ErrorService = ErrorService;

	this.options = [
		{ key: 12, value: "12 per page" },
		{ key: 25, value:  "25 per page" },
		{ key: 50, value: "50 per page" },
		{ key: 100, value: "100 per page" },
		{ key: 200, value: "200 per page" }
	]

	this.take = 12

	$rootScope.$emit('meta.refreshed', { page_title: 'ATMGurus Login Page', description: 'ATMGurus Login Page'});

	this.check = function(email, p) {
		this.errorMsg = '';
		this.ErrorService.reset('authError')
		Auth.login(email, p)
			.then((response) => {
				if ($location.search().urlback) {
					$location.url($location.search().urlback)
				}
				else {
					$location.path('/');
				}
				User.init();
				Analytics.login(email);
			})
		.catch(response => {
			this.errorMsg = response.data.error.email[0];
			$scope.$digest()
		})
	}
}







// WEBPACK FOOTER //
// ./src/app/modules/ATMGLogin/ATMGLogin.js